import { useState } from "react";
import { Flex, Box, useColorModeValue } from "@chakra-ui/react";
import { getAppValue } from "src/utils/environment";
import Menu from "src/components/Menu";
import MenuItem from "src/components/Menu/Item";
import MenuItemText from "src/components/Menu/ItemText";
import { ReactComponent as AwakeIcon } from "./awake.svg";
import { ReactComponent as SleepingIcon } from "./sleeping.svg";
import { ReactComponent as ArrowIcon } from "./arrow-down.svg";

export default function PreviewSelect({ onSelect, isSleeping, Previews, t }) {
  const [isOpen, setIsOpen] = useState(false);
  const borderColor = useColorModeValue(
    "rgba(0, 0, 0, 0.09)",
    "rgba(255, 255, 255, 0.09)"
  );
  return (
    <>
      <Menu
        isOpen={isOpen}
        elevationLevel={2}
        onClose={() => setIsOpen(false)}
        placement="bottom-start"
        anchorProps={{
          position: "absolute",
          bottom: "12px",
          left: "12px"
        }}
        anchorEl={
          <Box
            fontSize="10px"
            lineHeight="14px"
            letterSpacing="0.4px"
            color="mediumEmphasis"
            px="8px"
            py="4px"
            onClick={() => setIsOpen(true)}
            whiteSpace="nowrap"
            borderRadius="12px"
            border="1px solid"
            borderColor={borderColor}
            _hover={{
              cursor: "pointer"
            }}
          >
            <Flex alignItems="center">
              {isSleeping ? (
                <Flex alignItems="center">
                  <Box
                    mr="4px"
                    sx={{
                      svg: {
                        fill: getAppValue({
                          bibino: "secondary",
                          barkio: "primary"
                        })
                      }
                    }}
                  >
                    <SleepingIcon />
                  </Box>
                  {t("avatar.sleepingPreview")}
                </Flex>
              ) : (
                <Flex alignItems="center">
                  <Box
                    mr="4px"
                    sx={{
                      svg: {
                        fill: "warningBase"
                      }
                    }}
                  >
                    <AwakeIcon />
                  </Box>
                  {t("avatar.awakePreview")}
                </Flex>
              )}
              <Box
                width="17px"
                height="17px"
                sx={{
                  svg: {
                    fill: "mediumEmphasis"
                  }
                }}
              >
                <ArrowIcon />
              </Box>
            </Flex>
          </Box>
        }
      >
        <MenuItem
          onClick={() => {
            onSelect(Previews.Sleeping);
            setIsOpen(false);
          }}
        >
          <MenuItemText>{t("avatar.sleepingPreview")}</MenuItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onSelect(Previews.Awake);
            setIsOpen(false);
          }}
        >
          <MenuItemText>{t("avatar.awakePreview")}</MenuItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
